
import { useNavigate } from 'react-router-dom';

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "../components/MDBox";

// dependencies
import { useEffect, useState } from "react";
// import { toast } from "react-toastify";

// Material Dashboard 2 React example components
import { Container } from "@mui/material";

// utilities
import Pagination from "../components/lbic_component/Pagination";
import BasicTable from "../components/lbic_component/Table";

// css
import "../assets/CSS/index.css";
import { ClientCall } from "../context/allotees/apiClass";

function ClaimReportHistory() {
  const [reports, setReports] = useState([]);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();

  useEffect(() => {
    ClientCall(null,'get','/view-report',null,callback,errCallback,'null','allotee')
  }, []);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  let currentDatas = reports.length > 0 ? reports.slice(indexOfFirstData, indexOfLastData): []

  const callback = (response) => {
    let transaction = {};
    let reportArr = []
    for (const key in transaction = response.reports) {
        reportArr.push(transaction[key])
      if(Object.keys(transaction).length === reportArr.length){
        setReports(reportArr);
      }
    }
  };

  const errCallback = () => {
    console.log("Unsuccessful Request");
  };

  return (
    <Container className="container-dashboard">
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12}>
            <Pagination
              dataPerPage={dataPerPage}
              totalData={reports.length}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              range={3}
            />
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <BasicTable
            style={{ width: "100%" }}
            heading={[
              "Reference",
              "Location",
              "Flat No.",
              "Date Of Occurence",
              "Estimation",
              "Status"
            ]}
            values={["reference", "location", "flat_no", "date_of_occurence", "estimate_of_repair"]}
            data={currentDatas}
            color="#343a40"
            textAlign="center"
            alignValues="center"
            propertyToCheck="status"
            valueToCompare={0}
            toFormat={['estimate_of_repair currency','date_of_occurence time']}
            type={['time', 'currency']}
            ifTrueComponent={<p style={{backgroundColor: "red", padding:"1px 6px", fontSize: "11px", color: "#FFFFFF",textAlign:"center", width: "fit-content", marginRight: "auto", marginLeft: "auto"}}>Open</p>}
            notTrueComponent={<p style={{backgroundColor: "green", padding:"1px 6px", fontSize: "11px", color: "#FFFFFF",textAlign:"center", width: "fit-content", marginRight: "auto", marginLeft: "auto"}}>Closed</p>}
          />
        </MDBox>
        <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}></Grid>
            <Grid item xs={12} md={6} lg={4}></Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Container>
  );
}

export default ClaimReportHistory;
